module.exports = __webpack_public_path__ + "img/dsci0054.a34cae93.jpg";